import { Card, Stack, Text } from '@mantine/core'
import { IconMessage } from '@tabler/icons-react'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_layout/students/$studentNo/conversations/')({
    component: RouteComponent,
})

function RouteComponent() {
    return (
        <Card className={'p={0} pt={0} radius={0}'} h={'100%'}>
            <Stack align={'center'} justify={'center'} gap={'xs'} className={'h-[50%]'}>
                <IconMessage size={38} color={'var(--mantine-color-dimmed)'} />
                <Text size='sm' fw={500} c={'dimmed'}>No conversation selected</Text>
                <Text size='sm' c={'dimmed'}>Select a conversation to view the messages</Text>
            </Stack>
        </Card>
    )
}
